import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { fail_retrieve_tenant_promotions_code_lookup_integration_settings, loading_retrieve_tenant_promotions_code_lookup_integration_settings, reset_retrieve_tenant_promotions_code_lookup_integration_settings, success_retrieve_tenant_promotions_code_lookup_integration_settings } from '../../../reducers/auth_tenant/retrieve_tenant_promotions_code_lookup_integration_settings_Slice';
import { TENANT_RETRIEVE_CODE_LOOK_UP_INTEGRATION_SETTINGS_API, TENANT_UPDATE_PROMOTION_CODE_LOOKUP_INTEGRATION_SETTINGS_API } from '../../../api/api_data';
import { RETRIVE_SETTINGS_DETAILS_ERROR_MSG, RETRIVE_SETTINGS_DETAILS_SUCCESS_MSG, UPDATE_SETTINGS_DETAILS_ERROR_MSG, UPDATE_SETTINGS_DETAILS_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { getSelectedOption, messageToast } from '../../../utils/Utils';
import * as app_consts from "../../../utils/app_consts";
import { Button, Col, Icon, Row, RSelect } from '../../Component';
import TextInput from '../../../pages/components/inputs/TextInput';
import { fail_update_promotion_code_lookup_integration_settings, loading_update_promotion_code_lookup_integration_settings, reset_update_promotion_code_lookup_integration_settings, success_update_promotion_code_lookup_integration_settings } from '../../../reducers/auth_tenant/update_promotion_code_lookup_integration_settings_Slice';
import moment from 'moment';

const initial_state = { promotion_id: "", provider: "", client_id: "", client_secret: "", campaign_id: "", integration_type: "" };

const ViewCodesLookUpPromotionDetailsModal = ({ isOpen, closeModal, tenant_info, user_info, successFunction, data }) => {

  const [page_data, setPageData] = useState([]);
  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);
  const [form_data, setFormData] = useState(initial_state);
  const [update_loading, setUpdateLoading] = useState(false);
  const [update_error, setUpdateError] = useState("");
  const [integration_types, setIntegrationTypes] = useState([]);
  const [sent_data, setSentData] = useState(data);

  useEffect(() => {
    if (isOpen && data)
    {
      // Dispatch
      setEditMode(false);
      retrieve_data(data);
      setSentData(data);
      setUpdateError('');
      setError("");
    }
    setOpen(isOpen);
  }, [isOpen, data]);

  const retrieve_data = (id) => {
    setError('');
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_promotions_code_lookup_integration_settings, success_retrieve_tenant_promotions_code_lookup_integration_settings, fail_retrieve_tenant_promotions_code_lookup_integration_settings, RETRIVE_SETTINGS_DETAILS_ERROR_MSG, RETRIVE_SETTINGS_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_CODE_LOOK_UP_INTEGRATION_SETTINGS_API}/${id}`));
  };

  // Listener
  const retrieve_tenant_promotions_code_lookup_integration_settings_listener = useSelector((state) => state.retrieve_tenant_promotions_code_lookup_integration_settings.retrieve_tenant_promotions_code_lookup_integration_settings);

  useEffect(() => {
    if (retrieve_tenant_promotions_code_lookup_integration_settings_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_promotions_code_lookup_integration_settings_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (retrieve_tenant_promotions_code_lookup_integration_settings_listener.status === app_consts.FAIL)
        {
          setError(retrieve_tenant_promotions_code_lookup_integration_settings_listener.message);
          messageToast(retrieve_tenant_promotions_code_lookup_integration_settings_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_promotions_code_lookup_integration_settings_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_promotions_code_lookup_integration_settings_listener.data);
        }
        setLoading(false);
        dispatch(reset_retrieve_tenant_promotions_code_lookup_integration_settings());
      }
    }
  }, [retrieve_tenant_promotions_code_lookup_integration_settings_listener]);

  const handle_provider_select = (value) => {
    // Find Provider
    const filtered_data = page_data?.create_edit_settings_data?.find((item) => item?.provider === value);

    setIntegrationTypes(filtered_data?.integration_types || []);

    setFormData({ ...form_data, provider: value, integration_type: "" });
  };

  // Handle Change Function
  const handleChange = (e) => {
    setFormData({ ...form_data, [e.target.name]: e.target.value });
  };

  const handle_edit_lookup_integration_config = () => {
    setUpdateError('');
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_update_promotion_code_lookup_integration_settings, success_update_promotion_code_lookup_integration_settings, fail_update_promotion_code_lookup_integration_settings, UPDATE_SETTINGS_DETAILS_ERROR_MSG, UPDATE_SETTINGS_DETAILS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_UPDATE_PROMOTION_CODE_LOOKUP_INTEGRATION_SETTINGS_API}`, { ...form_data, promotion_id: sent_data }));
  };

  // Listener
  const update_promotion_code_lookup_integration_settings_listener = useSelector((state) => state.update_promotion_code_lookup_integration_settings.update_promotion_code_lookup_integration_settings);

  useEffect(() => {
    if (update_promotion_code_lookup_integration_settings_listener.status !== app_consts.IDLE)
    {
      if (update_promotion_code_lookup_integration_settings_listener.status === app_consts.LOADING)
      {
        setUpdateLoading(true);
        setUpdateError("");
      } else
      {
        setUpdateLoading(false);
        if (update_promotion_code_lookup_integration_settings_listener.status === app_consts.FAIL)
        {
          setUpdateError(update_promotion_code_lookup_integration_settings_listener.message);
          messageToast(update_promotion_code_lookup_integration_settings_listener.message, app_consts.FAIL);
        } else if (update_promotion_code_lookup_integration_settings_listener.status === app_consts.SUCCESS)
        {
          messageToast(UPDATE_SETTINGS_DETAILS_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
          retrieve_data(sent_data);
          setEditMode(false);
        }
        dispatch(reset_update_promotion_code_lookup_integration_settings());
      }
    }
  }, [update_promotion_code_lookup_integration_settings_listener]);

  return (
    <>
      <Modal isOpen={open} toggle={loading ? "" : closeModal} className="modal-dialog-centered" size={"md"}>
        <ModalHeader toggle={loading ? "" : closeModal}>Code Lookup Integration Settings</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>Retrieving Code Look Up Settings...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <div className='mt-4'>
                      </div>
                      {
                        editMode ?
                          <>
                            <Row className="g-4">
                              <Col lg={12}>
                                <div className="form-group">
                                  <div className="form-label-group">
                                    <label className="form-label">
                                      <label className="form-label mb text-md" htmlFor="retrunable">
                                        Provider<span className='text-danger pr-2'>{` *`}</span>
                                      </label>
                                    </label>
                                  </div>
                                  <div className="w-100">
                                    <RSelect
                                      options={page_data?.create_edit_settings_data}
                                      className="w-100"
                                      placeholder="Search"
                                      value={getSelectedOption(form_data?.provider, page_data?.create_edit_settings_data)}
                                      onChange={(e) => handle_provider_select(e.value)}
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col lg={12}>
                                <div className="form-group">
                                  <div className="form-label-group">
                                    <label className="form-label">
                                      <label className="form-label mb text-md" htmlFor="retrunable">
                                        Integration Type<span className='text-danger pr-2'>{` *`}</span>
                                      </label>
                                    </label>
                                  </div>
                                  <div className="w-100">
                                    <RSelect
                                      options={integration_types}
                                      className="w-100"
                                      isDisabled={!form_data?.provider}
                                      placeholder="Search"
                                      value={getSelectedOption(form_data?.integration_type, integration_types)}
                                      onChange={(e) => { setFormData({ ...form_data, integration_type: e?.value }); }}
                                    />
                                  </div>
                                </div>
                              </Col>
                              {
                                form_data?.integration_type === app_consts.CAMPAIGN_ID_CLIENT_ID_CLIENT_SECRET && (
                                  <>
                                    <TextInput
                                      label="Campaign ID"
                                      type="text"
                                      id_val="campaign_id"
                                      value={form_data?.campaign_id}
                                      colSize="12"
                                      required
                                      name="campaign_id"
                                      handleChange={handleChange}
                                    />
                                    <TextInput
                                      label="Client ID"
                                      type="text"
                                      id_val="client_id"
                                      value={form_data?.client_id}
                                      colSize="12"
                                      required
                                      name="client_id"
                                      handleChange={handleChange}
                                    />
                                    <TextInput
                                      label="Client Secret"
                                      type="text"
                                      id_val="name"
                                      value={form_data?.client_secret}
                                      colSize="12"
                                      required
                                      name="client_secret"
                                      handleChange={handleChange}
                                    />
                                  </>
                                )
                              }
                            </Row>
                            <hr />
                            <Row className="g-4 mt-4">
                              {update_error && (
                                <div className="mb-3 w-100">
                                  <Alert color="danger" className="alert-icon">
                                    <Icon name="alert-circle" /> {update_error}{" "}
                                  </Alert>
                                </div>
                              )}
                              <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                                <Button className='mx-2' onClick={() => setEditMode(false)} disabled={update_loading} color="gray">
                                  Cancel
                                </Button>
                                <Button onClick={handle_edit_lookup_integration_config} disabled={
                                  (update_loading) ||
                                  !(form_data?.provider && (form_data?.integration_type === app_consts.CAMPAIGN_ID_CLIENT_ID_CLIENT_SECRET ? (form_data?.campaign_id && form_data?.client_id && form_data?.client_secret) : true))
                                } color="primary">
                                  {update_loading ? <Spinner size="sm" color="light" /> : "Update Lookup Settings"}
                                </Button>
                              </Col>
                            </Row>
                          </>
                          :
                          <>
                            {
                              page_data?.code_integration_settings ?
                                <>
                                  <div className="m-auto d-flex flex-row justify-content-start align-center my-4" >
                                    <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData({ initial_state }); }} color="primary" size="sm">
                                      Edit Code Integration Settings
                                    </Button>
                                  </div>
                                  <Row className="g-4">
                                    <TextInput
                                      label="Provider"
                                      type="text"
                                      id_val="provider"
                                      value={page_data?.code_integration_settings?.provider?.replace(/_/g, ' ').toUpperCase() || "--"}
                                      colSize="12"
                                      disabled
                                      name="provider"
                                    />
                                    <TextInput
                                      label="Integration Type"
                                      type="text"
                                      id_val="integration_type"
                                      value={page_data?.code_integration_settings?.integration_type?.replace(/_/g, ' ').toUpperCase() || "--"}
                                      colSize="12"
                                      disabled
                                      name="integration_type"
                                    />
                                    {
                                      page_data?.code_integration_settings?.integration_type === app_consts.CAMPAIGN_ID_CLIENT_ID_CLIENT_SECRET && (
                                        <>
                                          <TextInput
                                            label="Campaign ID"
                                            type="text"
                                            id_val="campaign_id"
                                            value={page_data?.code_integration_settings?.campaign_id?.replace(/_/g, ' ').toUpperCase() || "--"}
                                            colSize="12"
                                            disabled
                                            name="campaign_id"
                                          />
                                          <TextInput
                                            label="Client ID"
                                            type="text"
                                            id_val="client_id"
                                            value={page_data?.code_integration_settings?.client_id?.replace(/_/g, ' ').toUpperCase() || "--"}
                                            colSize="12"
                                            disabled
                                            name="client_id"
                                          />
                                        </>
                                      )
                                    }
                                    <TextInput
                                      label="Last Updated On"
                                      type="text"
                                      id_val="last_updated_on"
                                      value={page_data?.code_integration_settings?.last_updated_on ? moment(page_data?.code_integration_settings?.last_updated_on).format("YYYY-MM-DD HH:mm:ss") : "--"}
                                      colSize="12"
                                      disabled
                                      name="last_updated_on"
                                    />
                                  </Row>
                                </>
                                :
                                <>
                                  <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                                    <div className="text-soft fw-bold my-4" style={{ fontSize: 18 }}>Code Integration Settings Have not Been Set</div>

                                    <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData(initial_state); }} color="primary" size="sm">
                                      Add Code Integration Settings
                                    </Button>
                                  </div>
                                </>
                            }
                          </>
                      }
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default ViewCodesLookUpPromotionDetailsModal;